// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2482":"88ea648c570fd6b7","4863":"3dacb20b7570326d","6331":"3084b002a1baf131","7057":"a9b0b134b862db8f","9651":"bddd959a7c85efc2"}[chunkId] + ".js";
};